module.exports = __webpack_public_path__ + "2240610236d16727e548f3afcdbadaa7.svg";